import * as actions from "../actions/eventsActions";
import produce from "immer";
import isEqual from "lodash.isequal";

const initialState = {
  eventsType: "all",
  live: {},
  prematch: {},
  event: null,
  counts: {},
  menu: {},
  filters: {
    game: false,
    league: false,
    search: false
  }
};

export default function events(state = initialState, action) {
  switch (action.type) {
    case actions.SET_TYPE: {
      return {
        ...state,
        eventsType: action.eventsType,
        filters: initialState.filters
      };
    }
    case actions.SET_EVENTS: {
      // TODO: rewrite
      return produce(state, draft => {
        const eventIds = {};
        let liveCount = 0;
        let prematchCount = 0;

        action.events.forEach(event => {
          delete event['u_time'];

          if (event.live) {
            liveCount += 1;
          } else {
            prematchCount += 1;
          }

          const store = event.live ? "live" : "prematch";
          const eventId = event.event_id;
          const oldEvent = state[store][eventId];

          eventIds[eventId] = true;

          if (!oldEvent || !isEqual(oldEvent, event)) {
            draft[store][eventId] = event;
          }
        }, {});

        Object.keys(state.live).forEach(eventId => {
          if (!eventIds[eventId]) {
            delete draft.live[eventId];
          }
        })

        Object.keys(state.prematch).forEach(eventId => {
          if (!eventIds[eventId]) {
            delete draft.prematch[eventId];
          }
        })

        const allCount = liveCount + prematchCount;

        if (state.counts.live !== liveCount) {
          draft.counts.live = liveCount;
        }

        if (state.counts.prematch !== prematchCount) {
          draft.counts.prematch = prematchCount;
        }

        if (state.counts.all !== allCount) {
          draft.counts.all = allCount;
        }
      });
    }
    case actions.SET_EVENT: {
      return {
        ...state,
        event: action.event
      };
    }
    case actions.SET_MENU: {
      return {
        ...state,
        menu: action.menu
      };
    }
    case actions.SET_GAME_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          game: action.game,
          league: initialState.filters.league
        }
      };
    }
    case actions.SET_LEAGUE_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          league: action.league
        }
      };
    }
    case actions.SET_SEARCH_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          search: action.search
        }
      };
    }
    default: {
      return state;
    }
  }
}


// WEBPACK FOOTER //
// ./app/reducers/events.js